import 'css-chunksrc/client/common/organizationalUnitsHierarchy/styles.scss';export default {
  "organizationalUnitsHierarchy": "_organizationalUnitsHierarchy_1yh50_1",
  "search": "_search_1yh50_6",
  "scrollPane": "_scrollPane_1yh50_11",
  "loader": "_loader_1yh50_15"
};